
import { useState, useEffect } from "react";
import { getGroupsAsync } from "@/lib/restaurant-groups";
import type { RestaurantGroup } from "@/lib/restaurant-groups";

/** Hook that loads restaurant groups from API on mount */
export function useGroups() {
  const [groups, setGroups] = useState<RestaurantGroup[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getGroupsAsync().then((g) => {
      setGroups(g);
      setLoaded(true);
    });
  }, []);

  return { groups, loaded };
}
